import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@raketa-cms/raketa-cms';

const Content = ({ title, subtitle, content }) => (
  <div className="eight">
    <div className="content-wrapper">
      <div className="content">
        <h3>{title}</h3>

        <h6>{subtitle}</h6>

        <div className="divider"></div>

        {content &&
          <div dangerouslySetInnerHTML={{ __html: content }} />
        }
      </div>
    </div>
  </div>
);

const Quote = ({ quote }) => (
  <div className="third">
    <div className="quote-content-wrapper">
      <div className="quote-content box-shadow">
        {quote &&
          <div dangerouslySetInnerHTML={{ __html: quote }} />
        }

        <a href={`//twitter.com/home?status=${quote.replace(/(<([^>]+)>)/ig, '')}`} target="_blank"><img src="data:image/svg+xml;base64,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" alt="Twitter logo" className="icon-twitter"/></a>
      </div>
    </div>
  </div>
);

const SpotlightAndQuoteWidget = ({
  title,
  subtitle,
  content,
  quote,
  containerSettings
}) => (
  <Container settings={containerSettings}>
      <div className="text-and-sidebar">
        <div className="container">
          <div className="grid">
            <Content
              title={title}
              subtitle={subtitle}
              content={content}
            />

            <Quote quote={quote}/>
          </div>
        </div>
      </div>
  </Container>
);

SpotlightAndQuoteWidget.title = 'Spotlight + Quote';
SpotlightAndQuoteWidget.category = 'Highlights';

SpotlightAndQuoteWidget.dialogSize = 'large';

SpotlightAndQuoteWidget.defaults = {
  title: "REFRAMING WHAT MATERNAL MORBIDITY AND MATERNAL HEALTH MEANS",
  subtitle: "for women, children, communities and economies",
  content: "<p>The work to improve maternal health has traditionally focused on preventing women from dying during pregnancy and childbirth. But maternal mortality is a tragic but rare event, which only stands for a small fraction of all the different kinds of burdens that women may face in relation to their pregnancies.</p>"
  + "<p>A positive pregnancy experience is a woman’s right. Reducing maternal morbidities is key to ensuring lifelong health - and fundamental if we are serious about empowering women to unleash their full potential, as contributing members of families, communities, societies and economies.</p>",
  quote: "<blockquote>A positive pregnancy experience is a woman\’s <strong>right</strong></blockquote>"
};

SpotlightAndQuoteWidget.adminFields = {
  title: { type: 'text' },
  subtitle: { type: 'text' },
  content: { type: 'rich' },
  quote: {type: 'rich' },
};

export default SpotlightAndQuoteWidget;
